import { Box } from '@skin-seoul/design-system';
import React from 'react';

interface CheckIconProps {
  achieved: boolean;
}

export function CheckIcon({ achieved }: CheckIconProps) {
  return (
    <Box
      width="24px"
      height="24px"
      bg={achieved ? 'success.600' : 'neutral.600'}
      display="flex"
      alignItems="center"
      borderRadius="12px"
      justifyContent="center"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
        <path d="M1 2.99805L3 4.99805L7 0.998047" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Box>
  );
}
